var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 401,
    viewBox: "0 0 433 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1168_2206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.389 256.316H267.61C272.501 256.316 277.191 258.259 280.649 261.717C284.107 265.175 286.05 269.866 286.05 274.756V461H174.949V274.756C174.949 269.866 176.892 265.175 180.35 261.717C183.808 258.259 188.499 256.316 193.389 256.316Z",
    fill: "#BFA2F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.844 179.689C238.596 209.027 230.501 312.3 230.501 312.3C230.501 312.3 155.496 292.08 132.049 241.435C118.219 211.525 125.927 174.498 151.273 157.441C176.619 140.384 209.11 150.351 223.844 179.689Z",
    fill: "#8046F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.156 179.689C222.404 209.027 230.5 312.3 230.5 312.3C230.5 312.3 305.504 292.08 328.951 241.435C342.781 211.525 335.073 174.498 309.727 157.441C284.381 140.384 251.89 150.351 237.156 179.689Z",
    fill: "#8046F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.871 299.06V349.77H269.262V299.06C269.262 296.125 268.096 293.311 266.021 291.236C263.946 289.162 261.132 287.996 258.198 287.996H245.935C243.001 287.996 240.187 289.162 238.112 291.236C236.037 293.311 234.871 296.125 234.871 299.06Z",
    fill: "#BFA2F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.815 301.752V314.872H241.314V301.752C241.314 299.796 242.092 297.92 243.475 296.536C244.858 295.153 246.734 294.376 248.69 294.376H255.439C257.396 294.376 259.272 295.153 260.655 296.536C262.038 297.92 262.815 299.796 262.815 301.752Z",
    fill: "#DFF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.01 412.743L295.989 377.651",
    stroke: "#8046F2",
    strokeWidth: 18.44,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.989 413.932L165.01 378.831",
    stroke: "#8046F2",
    strokeWidth: 18.44,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1168_2206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 461,
    height: 461,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo1);
export default __webpack_public_path__ + "static/media/co1.477cb6018b1c51384ad052d4dfdcc8c9.svg";
export { ForwardRef as ReactComponent };